import React, { ReactNode } from 'react';
import styled, { ThemeProvider, useTheme } from 'styled-components';
import { automotive, covideo, kennected, app2vid, provideo } from './index';

interface IProps {
  children: ReactNode;
  themeName: 'covideo' | 'automotive' | 'kennected' | 'app2vid' | 'provideo';
}

const theme = {
  covideo,
  automotive,
  kennected,
  app2vid,
  provideo,
};

export const CovideoThemeProvider = ({ children, themeName }: IProps) => {
  return <ThemeProvider theme={theme[themeName]}>{children}</ThemeProvider>;
};

export { useTheme as useCovideoTheme, styled as covideoStyled };
